// @flow
import { applyMiddleware, compose, createStore } from 'redux'
import { reducer, middlewares } from '../reducers';

const configureStore = () => {

  const enhancers = [
    applyMiddleware(...middlewares),
  ];
  const composeEnhancers = (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;
  
  const enhancer = composeEnhancers(...enhancers);
  
  const store = createStore(
    reducer,
    undefined,
    enhancer,
  );

  return store;
}

export default configureStore;